import { render, staticRenderFns } from "./BadgeNew.vue?vue&type=template&id=7f6b80eb&"
import script from "./BadgeNew.vue?vue&type=script&lang=js&"
export * from "./BadgeNew.vue?vue&type=script&lang=js&"
import style0 from "./BadgeNew.vue?vue&type=style&index=0&id=7f6b80eb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports